import PropTypes from 'prop-types';
import React from "react";

const SVG = ({
  style = {},
  fill = "#444",
  width = "100%",
  height = "100%",
  className = "",
  direction = 'obtuse-right',
  viewBox = "0 0 100 100"
}) => {
  let dir;
  switch (direction) {
    case 'obtuse-right':
      dir='0,100 100,0 100,100';
      break;
    case 'obtuse-left':
      dir='0,100 100,100 0,0';
      break;
    default:
      break;
  }
  
  return(
    <svg
      width={width}
      style={style}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`svg-icon ${className || ""}`}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <polygon fill={fill} points={dir} />  
    </svg>
  )
};

SVG.propTypes = {
  direction: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string
};

export default SVG;
